import React from 'react';
import TabView from 'src/components/Detail/TabView';
import VehicleDetailTab from 'src/components/Vehicle/Detail/RightSectionTabs/VehicleDetailTab';
import VehicleTrackingLogTab from 'src/components/Vehicle/Detail/RightSectionTabs/VehicleTrackingLogTab';
import LocationTab from 'src/components/Vehicle/Detail/RightSectionTabs/LocationTab';

export default function RightSection({ vehicle, onTabChange }) {
  const tabDocumentComponents = [
    {
      id: 'vehicle-detail',
      title: 'Vehicle Detail',
      component: <VehicleDetailTab vehicle={vehicle} />,
    },
    {
      id: 'vehicle-tracking-log',
      title: 'Vehicle Tracking Log',
      component: <VehicleTrackingLogTab vehicle={vehicle} />,
    },
    {
      id: 'location-tab',
      title: 'Location Tab',
      component: <LocationTab vehicle={vehicle} />,
    },
  ];

  return (
    <TabView
      tabDocumentComponents={tabDocumentComponents}
      onTabChange={onTabChange}
    />
  );
}
